import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  Icon,
  Popover,
  PopoverContent,
  PopoverTrigger,
  RadioGroup,
  type RadioGroupItemProps,
} from "@tenant/ui";
import clsx from "clsx";
import styles from "./styles.module.scss";

export type AvailabilityListSortComponentProps = PlatformComponentProps & {
  sortOptions: RadioGroupItemProps[];
  selectedSort: string;
  handleSortChange: (value: string) => void;
  getSortLabelKey: (value: string) => string;
};

export const AvailabilityListSort = ({
  children,
  className,
  sortOptions,
  selectedSort,
  handleSortChange,
  getSortLabelKey,
}: AvailabilityListSortComponentProps) => {
  const [, cn] = useModuleBEM(styles, "AvailabilityListSort");

  const { t } = useI18nContext();

  return (
    <Popover>
      <PopoverTrigger className={clsx(cn("sort-button"), className)}>
        <span>
          <span className={cn("sort-label")}>
            {t("core-hotels.availabilityPage.sort.dropDownLabel")}
          </span>
          {getSortLabelKey(selectedSort)}
        </span>
        <Icon iconName={IconNameEnum.dropdownTriangle} />
      </PopoverTrigger>
      <PopoverContent
        className={clsx(cn("sort-content"), className)}
        align="end"
      >
        <RadioGroup
          options={sortOptions}
          selectedOption={selectedSort}
          onSelectValue={(value) => handleSortChange(value)}
          className={cn("radio-group")}
        />
        {children}
      </PopoverContent>
    </Popover>
  );
};
